export class ProjectFilter {
	public from: Date | null;
	public to: Date | null;

	public constructor(from: Date | null, to: Date | null) {
		this.from = from;
		this.to = to;
	}
}
